const defaultReports = `{
  "reports": {
  }
}`;

export default defaultReports;
